<template>
    <div class="ax-road-side-bar">
        <router-link
            v-for="(item, i) in items"
            :key="i"
            v-tooltip="{
                content: item.disabled ? $t('no_permission') : item.label,
                placement: 'right',
            }"
            :to="(!item.disabled && { name: item.routeName }) || ''"
            class="ax-road-side-bar__item"
            :class="{ 'ax-road-side-bar__item--disabled': item.disabled }"
        >
            <component :is="item.icon" :width="24" :height="24" />
        </router-link>
    </div>
</template>

<script>
import TruckRightIcon from '@/components/icons/TruckRightIcon.vue'
import PersonIcon from '@/components/icons/PersonIcon.vue'
import WarningOutlinedIcon from '@/components/icons/WarningOutlinedIcon.vue'
import ZoneIcon from '@/components/icons/ZoneIcon.vue'
import GlobalSearchIcon from '@/components/icons/GlobalSearchIcon.vue'
import SettingsIcon from '@/components/icons/SettingsIcon.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'AxRoadSideBar',
    computed: {
        ...mapGetters('auth', ['hasTachographAccess', 'hasRulesAccess']),
        items() {
            return [
                {
                    icon: TruckRightIcon,
                    label: this.$t('shared.assets'),
                    routeName: 'axRoadTrucks',
                },
                {
                    icon: PersonIcon,
                    routeName: 'axRoadDrivers',
                    label: this.$t('ax_road.drivers'),
                    disabled: !this.hasTachographAccess,
                },
                {
                    icon: WarningOutlinedIcon,
                    label: this.$t('ax_road.warnings'),
                    routeName: 'axRoadWarnings',
                    disabled: !this.hasRulesAccess,
                },
                {
                    icon: ZoneIcon,
                    label: this.$t('ax_road.zones'),
                    routeName: 'axRoadZones',
                },
                {
                    icon: GlobalSearchIcon,
                    label: this.$t('ax_road.search'),
                    routeName: 'axRoadSearch',
                },
                {
                    icon: SettingsIcon,
                    label: this.$t('ax_road.settings'),
                    routeName: 'axRoadSettings',
                    disabled: true,
                },
            ]
        },
    },
}
</script>

<style lang="scss" scoped>
.ax-road-side-bar {
    width: 70px;
    padding: 16px 8px;
    background: $color-primary-contrast;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__item {
        display: flex;
        justify-content: center;
        width: 100%;
        padding: 12px 0;
        border-radius: 6px;
        text-align: center;

        &.router-link-active {
            background: $color-gray-light;
        }

        & > svg {
            display: block;
        }

        &--disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }
    }

    @include respond-to('for-mobile-down') {
        width: 58px;
    }
}
</style>

<i18n>
{
    "en": {
        "no_permission": "No access"
    },
    "de": {
        "no_permission": "Kein Zugriff"
    },
    "it": {
        "no_permission": "Nessun accesso"
    },
    "fr": {
        "no_permission": "Aucun accès"
    }
}
</i18n>
